(function () {
  function init(scope) {
    var root = scope || document;
    var items = root.querySelectorAll ? root.querySelectorAll('.jja-reveal:not([data-jja-reveal-ready]), .jja-hero:not([data-jja-reveal-ready])') : [];

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

    Array.prototype.forEach.call(items, function (item) {
      item.setAttribute('data-jja-reveal-ready', 'true');
      observer.observe(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
